type EmptyStateProps = {
  styles: Record<string, string>;
};

export function EmptyState({ styles }: EmptyStateProps) {
  return (
    <div className={styles.emptyState}>
      <div className={styles.welcomeIcon}>👑</div>
      <p className={styles.emptyTitle}>I'm Solomon, your AI ministry assistant</p>
      <p className={styles.emptyDescription}>I can help you with:</p>
      <ul className={styles.capabilitiesList}>
        <li>📸 Generate and manage profile images</li>
        <li>📊 Analyze your ministry's performance</li>
        <li>✍️ Create content and descriptions</li>
        <li>💡 Answer questions about your Studio</li>
      </ul>
      <p className={styles.emptyHint}>Just type a message below to get started</p>
    </div>
  );
}
